export interface ILoggingService {
    error(message?: any, ...params: any[]): any;
    warning(message?: any, ...params: any[]): any;
    info(message?: any, ...params: any[]): any;
}

export const createConsoleLoggingService = (): ILoggingService => {
    return {
        error: (message?: any, ...params: any[]) => {
            console.error(message, params);
        },
        warning: (message?: any, ...params: any[]) => {
            console.warn(message, params);
        },
        info: (message?: any, ...params: any[]) => {
            const styles = ['border: 1px solid #004085', 'color: #004085', 'padding: 2px', 'background: #cce5ff', 'font-size: 12px'].join(';');
            console.groupCollapsed('%c' + message, styles, params);
            console.trace();
            console.groupEnd();
        }
    };
};

export const createSilentLoggingService = (): ILoggingService => {
    return {
        error: (message?: any, ...params: any[]) => {
            console.error(message, params);
        },
        warning: (message?: any, ...params: any[]) => {
            console.warn(message, params);
        },
        info: () => { }
    };
};

interface IDevLogService {
    log: (message: string) => void;
    isEnabled: () => boolean;
}

export const devLogService: IDevLogService = (() => {

    if (window.document.location.href.indexOf("?devlog=1") >= 0 || window.document.location.href.indexOf("&devlog=1") >= 0) {
        document.cookie = "dodevlog=1;Path=/";
    }

    if (window.document.location.href.indexOf("?devlog=0") >= 0 || window.document.location.href.indexOf("&devlog=0") >= 0) {
        document.cookie = 'dodevlog=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }


    let canLog = document.cookie.indexOf("dodevlog=1") >= 0;

    const isEnabled = (): boolean => {
        return canLog;
    }

    const log = (message: string): void => {
        if (!canLog) {
            return;
        }

        let dest = window.document.getElementById("devlog");
        if (!dest) {
            return;
        }

        let time = new Date().toLocaleTimeString("cs-CS");

        dest.innerText += time + " " + message + "\n";

        console.warn(message);
    }

    return {
        isEnabled,
        log
    }
})();